import { create } from '@mizz/penny-core/entities/item'
import {
  save as saveApi,
  getById as getByIdApi,
  removeById
} from '@mizz/penny-firebase/repositories/items'
import { getCurrentUserId } from './auth'

export function getById(year, month, itemId) {
  return getByIdApi(year, month, itemId, getCurrentUserId())
}

export async function save(item) {
  const entity = create({
    ...item,
    description: (item.description || '').trim()
  })

  return saveApi(entity, item.id)
}

export async function remove(year, month, itemId) {
  return removeById(year, month, itemId)
}
